export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_MENU = "UPDATE_MENU";
export const UPDATE_WALLET = "UPDATE_WALLET";
export const SET_OTC_SETTING = "SET_OTC_SETTING";